import { IconButton, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import AddFieldButton from '../../AddFieldButton';
import { Delete } from '@mui/icons-material';
import { memo } from 'react';
import { produce } from 'immer';
import { get } from 'object-path';
import { fieldTemplatesState, layoutSelector } from 'state';
import { useRecoilState } from 'recoil';
import { getFieldIdsOfLayoutField } from 'routes/FormTemplateEditor/FormEditor/utils';
import { useTranslation } from 'react-i18next';

interface ColumnControlsProps {
  path: string;
  columnIndex: number;
  editDisabled?: boolean;
  width?: number;
}

function ColumnControls({
  path,
  columnIndex,
  editDisabled,
  width = 0,
}: ColumnControlsProps) {
  const { t } = useTranslation();
  const [layout, setLayout] = useRecoilState(layoutSelector);
  const [fieldTemplates, setFieldTemplates] =
    useRecoilState(fieldTemplatesState);

  const onDeleteColumn = () => {
    const items = produce(layout, draft => {
      get(draft, `${path}.children`).splice(columnIndex, 1);
    });

    const item = get(layout, `${path}.children.${columnIndex}`);
    const fieldItemsToBeRemoved = getFieldIdsOfLayoutField(item);

    const fieldItems = fieldTemplates.filter(fieldTemplate => {
      return !fieldItemsToBeRemoved?.includes(fieldTemplate.id);
    });

    setFieldTemplates(fieldItems);

    setLayout(items);
  };

  return (
    <Box
      width="100%"
      display="flex"
      alignItems={'center'}
      justifyContent={'end'}
    >
      <Typography
        ml={2}
        color={theme => theme.palette.text.disabled}
        fontSize={10}
        fontWeight={'bold'}
      >
        {`${width}/12`}
      </Typography>
      <AddFieldButton
        insertIndex={
          get(layout, `${path}.children.${columnIndex}.children`).length
        }
        parentPath={`${path}.children.${columnIndex}.children`}
        disabled={editDisabled}
        showLabel={width < 3 ? false : true}
      />
      <IconButton onClick={onDeleteColumn} size="small" disabled={editDisabled}>
        <Tooltip title={t('forms.deleteColumn')}>
          <Delete fontSize="small" />
        </Tooltip>
      </IconButton>
    </Box>
  );
}

export default memo(ColumnControls);
